module.exports = __webpack_public_path__ + "static/media/RBG_art_Amelia_Giller.eafcef66.png";